import React from 'react';
import AboutView from "../views/AboutView.js"

function AboutPresenter() {
  return (
    <AboutView/>
  )
}

export default AboutPresenter;
